import { LS } from 'constants/localization';
import { setAlert } from 'actions/viewActions';
import store from 'reducers/store';

export const convertJspJSONToJSON= (jspJSON) => {
  const leftTag = '&lt;';
  const leftTagReplacement = '<';
  const rightTag = '&gt;';
  const rightTagReplacement = '>';
  const amper = '&amp;';
  const amperReplacement = '&';
  const apos = '&#039;';
  const aposReplacement = '\'';
  const quot = '&#034;';
  const quotReplacement = '"';
  
  return handleJSON(JSON.parse(jspJSON
    .replaceAll(leftTag, leftTagReplacement)
    .replaceAll(rightTag, rightTagReplacement)
    .replaceAll(amper, amperReplacement)
    .replaceAll(apos, aposReplacement)
    .replaceAll(quot, quotReplacement)
  ));
};

// Handle error JSON
export const handleJSON = json => {
  try {
    return json;
  } catch {
    handleError(json);
  }
};

export const handleError = error => {
  console.log(error);
  // Expected errors have message as key to localized error msg
  let msg = error[LS.getLanguage()][error.message];

  if (!msg) {
    msg = error.message;
  }

  const { errorCode } = error;
  if (errorCode && errorCode !== 'null') {
    msg += ` [${error.errorCode}]`;
  }
  
  store.dispatch(setAlert({ contents: msg, variant: 'danger' }));
  // Throw exception to abort Promise chain
  throw new Error(msg);
};